/** @jsx jsx */
import { Fragment } from 'react'
import { Link } from 'gatsby'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import {
  Box,
  Button,
  Container,
  Flex,
  Grid,
  Heading,
  jsx,
  Text,
} from 'theme-ui'

const HeroSection = ({ cta, description, images, title }) => {
  const titlePieces = title.split('_')

  return (
    <Box bg="backgroundHomepageHero" sx={{ overflow: 'hidden' }}>
      <Container>
        <Grid columns={[1, null, 12]} sx={{ rowGap: '0' }}>
          {images && (
            <Box
              mx={[-2, -3, 0]}
              sx={{
                gridColumn: [null, null, '1 / 7'],
                height: [null, null, '552px'],
                position: [null, null, 'relative'],
              }}
            >
              <Box
                sx={{
                  height: ['187px', '280px', '552px'],
                  left: ['50%', null, 'auto'],
                  pointerEvents: 'none',
                  position: ['relative', null, 'absolute'],
                  right: [null, null, '0px'],
                  top: '0',
                  transform: ['translateX(-50%)', null, 'none'],
                  width: ['640px', '832px', '647px'],
                  '@media only screen and (min-width: 1240px)': {
                    height: '668px',
                    width: '783px',
                  },
                }}
              >
                <GatsbyImage
                  image={withArtDirection(getImage(images[1]), [
                    {
                      image: getImage(images[1]),
                      media: `(min-width: 832px)`,
                    },
                    {
                      image: getImage(images[0]),
                      media: `(min-width: 0px)`,
                    },
                  ])}
                  alt={images[0].description}
                  loading={'eager'}
                  style={{
                    height: '100%',
                    width: '100%',
                  }}
                />
              </Box>
            </Box>
          )}
          <Box
            pt={[3, 4]}
            pb={[5, 6]}
            sx={{
              display: [null, null, 'flex'],
              flexDirection: [null, null, 'column'],
              gridColumn: [null, null, '7 / -1'],
              justifyContent: [null, null, 'center'],
              '@media only screen and (min-width: 1240px)': {
                pl: 6,
              },
            }}
          >
            <Heading
              as="h1"
              variant="title0"
              color="brandPrimary"
              mb={[2, null, 3]}
            >
              <Text as="span">{`${titlePieces[0]} `}</Text>
              {titlePieces?.[1] && (
                <Fragment>
                  <br />
                  <Text as="span">
                    <em>{titlePieces[1]}</em>
                  </Text>
                </Fragment>
              )}
            </Heading>
            {description && (
              <Box>
                <Box
                  variant="text.body1"
                  sx={{
                    maxWidth: ['450px', '490px'],
                    '& p': { m: 0 },
                  }}
                  dangerouslySetInnerHTML={{
                    __html: description.childMarkdownRemark.html,
                  }}
                />
                {cta && (
                  <Flex
                    mt={4}
                    sx={{
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      a: {
                        textAlign: 'center',
                      },
                      '@media only screen and (max-width: 450px)': {
                        'div, a': {
                          width: '100%',
                        },
                        '& > div:first-child': {
                          mb: 2,
                          mr: 0,
                        },
                      },
                    }}
                  >
                    <Box mb={[null, null, 2]} mr={2}>
                      {cta}
                    </Box>
                    <Box>
                      <Button
                        as={Link}
                        to="/can-club/"
                        variant="secondary"
                        bg="white"
                      >
                        Join the Club
                      </Button>
                    </Box>
                  </Flex>
                )}
              </Box>
            )}
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default HeroSection
